import BigNumber from 'bignumber.js';

export const convertToPips = (value, pip_size) =>
    BigNumber(value)
        .multipliedBy(Math.pow(10, pip_size || 0))
        .toString();
